import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import Avatar from './avatar.gjs';
import Checkbox from 'ember-simplepractice/components/spds/input/checkbox';
import Component from '@glimmer/component';
import styles from './contact-list-item.module.scss';

export default class ContactListItem extends Component {
  get contact() {
    return this.args.contact;
  }

  get isInteractive() {
    return typeof this.args.onSelect === 'function';
  }

  get isDisabled() {
    return this.contact?.isDisabled === true;
  }

  get role() {
    return this.isInteractive ? 'button' : undefined;
  }

  get tabindex() {
    return this.isInteractive && !this.args.showCheckbox ? 0 : -1;
  }

  get userNames() {
    return this.contact?.members?.map(user => user.name).join(' & ') ?? '';
  }

  get isCoupleContact() {
    return this.contact?.members?.length === 2;
  }

  handleClick = () => {
    if (this.args.onSelect) {
      this.args.onSelect(this.contact);
    }
  };

  handleKeydown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  };

  handleCheckboxClick = ({ event }) => {
    // Since the list item click handler already handles state toggling, we need
    // to both prevent propagation and prevent default to avoid double toggling.
    event.target.blur();
    event.stopPropagation();
    event.preventDefault();
  };

  <template>
    <li
      class="{{styles.component}}
        contact-list-item
        {{unless this.isInteractive 'read-only'}}
        {{if this.isDisabled 'disabled'}}"
      data-test-contact={{this.contact.id}}
      data-test-contact-list-item
      role={{this.role}}
      tabindex={{this.tabindex}}
      aria-label={{if
        this.isInteractive
        (t "emc.contact_list_item.select_aria_label" userNames=this.userNames)
        undefined
      }}
      {{on "click" this.handleClick}}
      {{on "keydown" this.handleKeydown}}
      {{! Using variable to determine tabindex causes false positive in template-lint }}
      {{! template-lint-disable no-positive-tabindex }}
    >
      <Avatar @users={{this.contact.members}} @isCouple={{this.isCoupleContact}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{this.userNames}}</span>
          {{#if @showCheckbox}}
            <Checkbox
              @checked={{@isSelected}}
              @onClick={{this.handleCheckboxClick}}
              class="selection-checkbox"
            />
          {{/if}}
        </div>
        {{#if this.isDisabled}}
          <span class="disabled-notice" data-test-disabled-notice>
            {{t "emc.contact_list_item.disabled_notice"}}
          </span>
        {{/if}}
      </div>
    </li>
  </template>
}
